module.exports = __webpack_public_path__ + "static/media/ourService.66959a24.png";